/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import { Link } from 'gatsby';
import Layout from './layout';

const ArchivePage = ({ posts, title = '' }) => {
  const isSpanish = typeof window !== "undefined"
    ? window.location.pathname.includes("/es/")
    || !!window.location.pathname.match(/^.*\/es$/)
    : false;

  return (
    <Layout pageTitle={title}>
      {title && (
        <h2>
          {isSpanish ? 'Mostrando entradas para:' : 'Showing posts for:'} <span sx={{ color: 'secondary' }}>{title}</span>
        </h2>
      )}
      <ul sx={{ variant: 'list.blogroll' }}>
        {posts.map(({ title, path, tags, created, category, excerpt, language }) => (
          <li key={path}>
            <div>
              <h2 className="title">
                <Link to={path}>{title}</Link>
              </h2>
              <p className="taxonomy">
              {isSpanish ? 'Publicado en:' : 'Posted in:'} <Link to={language === 'es' ? '/es' + category.path : category.path}>{category.name}</Link>
              </p>
              {tags && (
                <p className="taxonomy">
                  {isSpanish ? 'Etiquetado en:' : 'Tagged under:'}{' '}
                  {tags.map(({ name, path }, i, tagsArr) => (
                    <React.Fragment key={path}>
                      <Link to={language === 'es' ? '/es' + path : path}>{name}</Link>
                      {i < tagsArr.length - 1 && ', '}
                    </React.Fragment>
                  ))}
                </p>
              )}
              {excerpt && <p className="excerpt">{excerpt}</p>}
            </div>
            <div className="timestamp">{created}</div>
          </li>
        ))}
      </ul>
    </Layout>
  );
};

export default ArchivePage;
